// extracted by mini-css-extract-plugin
export default {"container":"Help_container__ztqzt","help_frame":"Help_help_frame__VL4xJ","hidden":"Help_hidden__LVIwn"};